import React from "react";
import EditableFormattedMessage from "./EditableFormattedMessage";
import ppeFullLogo from '../ressources/logo-with-text-green.svg';

// Table row definitions: each row is an array of translation keys
const copingSelfRows = [
  {
    strategy: "SCOPE_REPORT_COPING_SELF_MODIFICATION",
    explanation: "SCOPE_REPORT_COPING_SELF_MODIFICATION_DESC",
    strengths: "SCOPE_REPORT_COPING_SELF_MODIFICATION_STRENGTHS",
    limits: "SCOPE_REPORT_COPING_SELF_MODIFICATION_LIMITS",
    noteIndex: 0,
  },
  {
    strategy: "SCOPE_REPORT_COPING_INTERNAL_ATTRIBUTION",
    explanation: "SCOPE_REPORT_COPING_INTERNAL_ATTRIBUTION_DESC",
    strengths: "SCOPE_REPORT_COPING_INTERNAL_ATTRIBUTION_STRENGTHS",
    limits: "SCOPE_REPORT_COPING_INTERNAL_ATTRIBUTION_LIMITS",
    noteIndex: 5,
  },
  {
    strategy: "SCOPE_REPORT_COPING_SELF_BOLSTERING",
    explanation: "SCOPE_REPORT_COPING_SELF_BOLSTERING_DESC",
    strengths: "SCOPE_REPORT_COPING_SELF_BOLSTERING_STRENGTHS",
    limits: "SCOPE_REPORT_COPING_SELF_BOLSTERING_LIMITS",
    noteIndex: 8,
  },
];

const copingCognitiveRows = [
  {
    strategy: "SCOPE_REPORT_COPING_PROBLEM_SOLVING",
    explanation: "SCOPE_REPORT_COPING_PROBLEM_SOLVING_DESC",
    strengths: "SCOPE_REPORT_COPING_PROBLEM_SOLVING_STRENGTHS",
    limits: "SCOPE_REPORT_COPING_PROBLEM_SOLVING_LIMITS",
    noteIndex: 1,
  },
  {
    strategy: "SCOPE_REPORT_COPING_RUMINATION",
    explanation: "SCOPE_REPORT_COPING_RUMINATION_DESC",
    strengths: "SCOPE_REPORT_COPING_RUMINATION_STRENGTHS",
    limits: "SCOPE_REPORT_COPING_RUMINATION_LIMITS",
    noteIndex: 4,
  },
  {
    strategy: "SCOPE_REPORT_COPING_WISHFUL_THINKING",
    explanation: "SCOPE_REPORT_COPING_WISHFUL_THINKING_DESC",
    strengths: "SCOPE_REPORT_COPING_WISHFUL_THINKING_STRENGTHS",
    limits: "SCOPE_REPORT_COPING_WISHFUL_THINKING_LIMITS",
    noteIndex: 7,
  },
];

export default function EditCopingDefinitionsPages({
  messagesData,
  locale,
  messages,
  updateMessage,
  graph,
  code,
  datePassed,
  keyPage,
  getThirdPosition, // Pass this as a prop if needed
}) {
  return (
    <div className="PageCharts-chart">
      <div className="header-logo-box">
        <img alt="ppe-logo" className="header-logo-img" src={ppeFullLogo} />
      </div>
      <div className="report-alt-page">
        <h1>
          <EditableFormattedMessage
            keys={messagesData}
            locale={locale}
            msgKey={graph.title}
            messages={messages}
            updateMessage={updateMessage}
          />
          <span className="inline font-16">
            {" "}
            -{" "}
            <EditableFormattedMessage
              keys={messagesData}
              locale={locale}
              msgKey="DEFINITIONS"
              messages={messages}
              updateMessage={updateMessage}
            />
          </span>{" "}
          1
        </h1>
        <span className="coping-sub-title">
          <b>
            <EditableFormattedMessage
              keys={messagesData}
              locale={locale}
              msgKey="SCOPE_REPORT_COPING_SELF_TITLE"
              messages={messages}
              updateMessage={updateMessage}
              defaultMessage="Coping impliquant soi-même"
            />
          </b>
        </span>
        <br />
        <table className="coping-table-fullwidth-less">
          <thead>
            <tr className="coping-table-header">
              <th>
                <EditableFormattedMessage
                  keys={messagesData}
                  locale={locale}
                  msgKey="SCOPE_REPORT_COPING_STRATEGY"
                  messages={messages}
                  updateMessage={updateMessage}
                  defaultMessage="Stratégie de coping"
                />
              </th>
              <th className="th-2">
                <EditableFormattedMessage
                  keys={messagesData}
                  locale={locale}
                  msgKey="SCOPE_REPORT_COPING_EXPLANATION"
                  messages={messages}
                  updateMessage={updateMessage}
                  defaultMessage="Explication"
                />
              </th>
              <th className="th-3">
                <EditableFormattedMessage
                  keys={messagesData}
                  locale={locale}
                  msgKey="SCOPE_REPORT_COPING_STRENGTHS"
                  messages={messages}
                  updateMessage={updateMessage}
                  defaultMessage="Forces"
                />
              </th>
              <th className="th-4">
                <EditableFormattedMessage
                  keys={messagesData}
                  locale={locale}
                  msgKey="SCOPE_REPORT_COPING_LIMITS"
                  messages={messages}
                  updateMessage={updateMessage}
                  defaultMessage="Limites"
                />
              </th>
              <th className="th-7">
                <EditableFormattedMessage
                  keys={messagesData}
                  locale={locale}
                  msgKey="SCOPE_REPORT_COPING_NOTE"
                  messages={messages}
                  updateMessage={updateMessage}
                  defaultMessage="Note"
                />
              </th>
            </tr>
          </thead>
          <tbody>
            {copingSelfRows.map((row, i) => (
              <tr className="coping-table-row" key={i}>
                <th>
                  <EditableFormattedMessage
                    keys={messagesData}
                    locale={locale}
                    msgKey={row.strategy}
                    messages={messages}
                    updateMessage={updateMessage}
                  />
                </th>
                <td>
                  <EditableFormattedMessage
                    keys={messagesData}
                    locale={locale}
                    msgKey={row.explanation}
                    messages={messages}
                    updateMessage={updateMessage}
                  />
                </td>
                <td>
                  <EditableFormattedMessage
                    keys={messagesData}
                    locale={locale}
                    msgKey={row.strengths}
                    messages={messages}
                    updateMessage={updateMessage}
                  />
                </td>
                <td>
                  <EditableFormattedMessage
                    keys={messagesData}
                    locale={locale}
                    msgKey={row.limits}
                    messages={messages}
                    updateMessage={updateMessage}
                  />
                </td>
                <td>
                  {/* Note: Use getThirdPosition or similar logic as needed */}
                  <EditableFormattedMessage
                    keys={messagesData}
                    locale={locale}
                    msgKey={getThirdPosition ? getThirdPosition(graph.data[row.noteIndex]) : ""}
                    messages={messages}
                    updateMessage={updateMessage}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <span className="coping-sub-title">
          <b>
            <EditableFormattedMessage
              keys={messagesData}
              locale={locale}
              msgKey="SCOPE_REPORT_COPING_COGNITIVE_TITLE"
              messages={messages}
              updateMessage={updateMessage}
              defaultMessage="Coping cognitif"
            />
          </b>
        </span>
        <br />
        <table className="coping-table-fullwidth-less">
          <thead>
            <tr className="coping-table-header">
              <th>
                <EditableFormattedMessage
                  keys={messagesData}
                  locale={locale}
                  msgKey="SCOPE_REPORT_COPING_STRATEGY"
                  messages={messages}
                  updateMessage={updateMessage}
                  defaultMessage="Stratégie de coping"
                />
              </th>
              <th className="th-2">
                <EditableFormattedMessage
                  keys={messagesData}
                  locale={locale}
                  msgKey="SCOPE_REPORT_COPING_EXPLANATION"
                  messages={messages}
                  updateMessage={updateMessage}
                  defaultMessage="Explication"
                />
              </th>
              <th className="th-3">
                <EditableFormattedMessage
                  keys={messagesData}
                  locale={locale}
                  msgKey="SCOPE_REPORT_COPING_STRENGTHS"
                  messages={messages}
                  updateMessage={updateMessage}
                  defaultMessage="Forces"
                />
              </th>
              <th className="th-4">
                <EditableFormattedMessage
                  keys={messagesData}
                  locale={locale}
                  msgKey="SCOPE_REPORT_COPING_LIMITS"
                  messages={messages}
                  updateMessage={updateMessage}
                  defaultMessage="Limites"
                />
              </th>
              <th className="th-7">
                <EditableFormattedMessage
                  keys={messagesData}
                  locale={locale}
                  msgKey="SCOPE_REPORT_COPING_NOTE"
                  messages={messages}
                  updateMessage={updateMessage}
                  defaultMessage="Note"
                />
              </th>
            </tr>
          </thead>
          <tbody>
            {copingCognitiveRows.map((row, i) => (
              <tr className="coping-table-row" key={i}>
                <th>
                  <EditableFormattedMessage
                    keys={messagesData}
                    locale={locale}
                    msgKey={row.strategy}
                    messages={messages}
                    updateMessage={updateMessage}
                  />
                </th>
                <td>
                  <EditableFormattedMessage
                    keys={messagesData}
                    locale={locale}
                    msgKey={row.explanation}
                    messages={messages}
                    updateMessage={updateMessage}
                  />
                </td>
                <td>
                  <EditableFormattedMessage
                    keys={messagesData}
                    locale={locale}
                    msgKey={row.strengths}
                    messages={messages}
                    updateMessage={updateMessage}
                  />
                </td>
                <td>
                  <EditableFormattedMessage
                    keys={messagesData}
                    locale={locale}
                    msgKey={row.limits}
                    messages={messages}
                    updateMessage={updateMessage}
                  />
                </td>
                <td>
                  <EditableFormattedMessage
                    keys={messagesData}
                    locale={locale}
                    msgKey={getThirdPosition ? getThirdPosition(graph.data[row.noteIndex]) : ""}
                    messages={messages}
                    updateMessage={updateMessage}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="pdf-footer">
        <EditableFormattedMessage
          keys={messagesData}
          locale={locale}
          msgKey="PAGE"
          messages={messages}
          updateMessage={updateMessage}
        />{" "}
        {keyPage + 1}
        <div className="pdf-footer-separator">
          <b>
            <EditableFormattedMessage
              keys={messagesData}
              locale={locale}
              msgKey="CANDIDATE"
              messages={messages}
              updateMessage={updateMessage}
            />
          </b>
        </div>{" "}
        {code}
        <div className="pdf-footer-separator">
          <b>
            <EditableFormattedMessage
              keys={messagesData}
              locale={locale}
              msgKey="TEST_DATE"
              messages={messages}
              updateMessage={updateMessage}
            />
          </b>{" "}
          {datePassed}
        </div>
      </div>
    </div>
  );
}